// tabs.js
;(() => {
    const tabActiveClass = 'tab_active'
    const contentActiveClass = 'tabs-content__section_active'
    const tabsGroups = document.querySelectorAll('.tabs-buttons')

    tabsGroups.forEach(group => {
        if (group.dataset.hasOwnProperty('disableJs')) { return }
        const groupName = group.dataset.tabsGroup
        const initIndex = group.dataset.tabsInitIndex
        const content = document.querySelectorAll(`.tabs-content[data-tabs-group="${groupName}"] > .tabs-content__section`)

        // console.log(group)

        const tabs = Array.from(group.querySelectorAll('.tabs-buttons__tab'))

        // console.log(tabs)
        
        tabs.forEach(tab => {
            if (tab) {
                tab.addEventListener('click', () => {
                    if (!tab.classList.contains(tabActiveClass)) {
                        resetTabs(tabs, content)
                        const index = tabs.indexOf(tab)
                        tab.classList.add(tabActiveClass)
                        content[index].classList.add(contentActiveClass)
                        CNS.tabEvent.tabsGroup = groupName
                        CNS.tabEvent.tabIndex = index
                        window.dispatchEvent(CNS.tabEvent)
                    } 
                })
            }
        })

        tabs[initIndex].click()
    })

    function resetTabs(tabs, content) {
        tabs.forEach(tab => {
            if (tab) {
                tab.classList.remove(tabActiveClass)
            }
        })
        content.forEach(cnt => {
            if (cnt) {
                cnt.classList.remove(contentActiveClass)
            }
        })
    }
})();